// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","light-grey":"#d4d4d4","wizardForm":"_17SIG9aFW0hUCr0gwSwuaU","inputsContainer":"_1lvu5dWfs7OUUNIQBekTwu","inputWrapper":"YnT1HUHTXWtzBy_vB-EoW","activeInputWrapper":"_3oACcjLfYcjVoaRaQ54ia_","left":"_2Ar5OmleBC4KopX7TDJoeb","right":"_3huEhonWAoNK1Ubj21B7iU","counter":"zM1SepZOGwyMN7S4bJdwb","progressLine":"_16odyUWsSc2yyUF4uWsrFx","successMessage":"_1NAKsrEDKnCW9S_BwrF0xx","onLastStep":"_9MetXOw6ECqSEkcqjGth_"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Form/WizardForm/WizardForm.css
// module id = 1326
// module chunks = 0